/* global newrelic */
import { setState, getState } from '../analytics-state';

const { take, put } = window.LIFE_CYCLE_EVENT_BUS.effects;
export const dataSources = () => {
  window.LIFE_CYCLE_EVENT_BUS.runEventSequence(function* dataSourceListener() {

    while (true) {
      const { output } = yield take('data-sources.data');
      const { variables, data, type } = output;
      if (type === 'product') {
        const { itemId } = variables || {};
        const products = {
          [itemId]: data,
          currentItemId: itemId
        };
        const dataSources = {//eslint-disable-line
          product: {
            [itemId]: data,
            currentItemId: itemId
          }
        };
        const state = setState({
          ...getState(),
          dataSources
        });
        yield put({
          type: 'thd-analytics.data',
          output,
          state
        });
      } else if (type === 'search') {

        const { searchModel } = data;
        const dataSources = {//eslint-disable-line
          search: {
            searchModel,
            variables
          }
        };

        const state = setState({ dataSources });

        yield put({
          type: 'thd-analytics.data',
          output,
          state
        });

      } else {
        const dataSources = {//eslint-disable-line
          [type]: {
            data,
            variables
          }
        };
        setState({ dataSources });
      }
    }
  });

};
